import React from "react"


const Load1 = () =>{
    return(
        <div className="cssload-thecube">
	<div className="cssload-cube cssload-c1"></div>
	<div className="cssload-cube cssload-c2"></div>
	<div className="cssload-cube cssload-c4"></div>
	<div className="cssload-cube cssload-c3"></div>
</div>

    )
}

export default Load1
